import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PrimaryTable from '../../helpers/primary-table'
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error'
import InputAuto from '../../helpers/input-auto';
import { CSVLink } from "react-csv";



const CanceledWOs = () => {
    const params = useParams();
    const navigate = useNavigate();
    let d = new Date();
    const formatted_today = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' + d.getFullYear();
    d.setDate(d.getDate() - 30);
    const formatted_thirty_days_ago = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' + d.getFullYear();
    const [woSearch, setWoSearch] = useState({
        start_date: formatted_thirty_days_ago,
        end_date: formatted_today

    });
    const [inputError, setInputError] = useState(false); const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [facilitiesNames, setFacilitiesNames] = useState([])

    const [client, setClient] = useState({
        client_id: params.client_id,
    });
    const [clients, setClients] = useState(null);
    const [csvHeader, setCsvHeader] = React.useState([
        { label: "DATE RANGE", key: "date_range" },
        { label: "CLIENT NAME", key: "client_company_name" },
        { label: "FACILITY NAME", key: "facility_name" },
        { label: "CASE NUMBER", key: "work_order_no" },
        { label: "CASE NAME", key: "case_name" },
        { label: "LAST STATUS UPDATE", key: "last_status" },
    ]);




    var columns = React.useMemo(
        () => [
          {
                accessorKey: "date_range",
                header: "DATE RANGE",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_company_name",
                header: "CLIENT",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_name",
                header: "FACILITY",
                footer: props => props.column.id
            },
            {
                accessorFn: row => <a className="btn btn-link" href={"/admin/work-order/" + row.work_order_id} >{row.work_order_no}</a>,
                id: "work_order_no",
                cell: info => info.getValue(),
                header: () => "Case Number",
                footer: props => props.column.id,
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
                id: "lastName",
                cell: info => info.getValue(),
                header: () => "CASE NAME",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.note_status,
                cell: info => info.getValue(),
                id: "last_status",
                header: "LAST STATUS UPDATE",
                footer: props => props.column.id
            }


        ],
        []
    )

    useEffect(() => {

        getClients();
        getFacilitiesNames();
        searchWorkOrders();


    }, []);



    const getClients = async () => {
          setInputError(false);
        if (!woSearch?.start_date || !woSearch?.end_date) {
            setInputError(true);
            return false;
        }
        setIsLoading(true);
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-clients/", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                setClients(response?.data?.clients);

                setIsLoading(false);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getFacilitiesNames = async (e) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facilities-names", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacilitiesNames(response?.data?.facilities);

            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }



    const searchWorkOrders = () => {

        setIsLoading(true);
        var search_elements = {}

        search_elements.client_company_name = woSearch?.client_company_name;
        search_elements.start_date = woSearch?.start_date;
        search_elements.end_date = woSearch?.end_date;
        search_elements.facility_name = woSearch?.facility_name;
        search_elements.case_manager_first_name = woSearch?.case_manager_first_name;


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-report-canceled-wos", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWorkOrders(response?.data?.work_orders);

            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-12 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">CANCELED WORK ORDERS</h3>
                </div>


            </div>

            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">

  <div className="col-2 my-1">
                                        <label htmlFor="invoice_date_range">START DATE</label>

                                        <DatePicker name="start_date" id="start_date" type="text"
                                            className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selectsStart
                                            isClearable={true}
                                            selected={woSearch?.start_date}
                                            onChange={(e) => {
                                                {
                                                    var dt = new Date(e);

                                                    const year = dt.getFullYear();
                                                    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                                    const day = dt.getDate().toString().padStart(2, "0");

                                                    const formatted_date = month + '/' + day + '/' + year

                                                    setWoSearch({ ...woSearch, start_date: formatted_date })

                                                }
                                            }
                                            }
                                        />
                                          {inputError && !woSearch?.start_date && (
                                    <span className="text-danger">Enter valid start date</span>
                                )}
                                    </div>
                                    <div className="col-2 my-1">
                                        <label htmlFor="invoice_date_range">END DATE</label>

                                        <DatePicker name="end_date" id="end_date" type="text"
                                            className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            selectsEnd
                                            isClearable={true}
                                            selected={woSearch?.end_date}
                                            onChange={(e) => {
                                                {
                                                    var dt = new Date(e);

                                                    const year = dt.getFullYear();
                                                    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                                    const day = dt.getDate().toString().padStart(2, "0");

                                                    const formatted_date = month + '/' + day + '/' + year

                                                    setWoSearch({ ...woSearch, end_date: formatted_date })

                                                }
                                            }
                                            }
                                        />
                                          {inputError && !woSearch?.end_date && (
                                    <span className="text-danger">Enter valid end date</span>
                                )}
                                    </div>
                            <div className="col-3 my-1">
                                <label htmlFor="client_id" >FACILITY</label>


                                <InputAuto name="facility_name" className="form-control" minStart="3"
                                    value={woSearch.facility_name}
                                    pholder=""
                                    data={facilitiesNames}
                                    field="facility_name"
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, facility_name: e })
                                    }
                                    onSelected={(e) => {
                                        setWoSearch({ ...woSearch, facility_name: e.facility_name })

                                    }
                                    }

                                />


                            </div>

                            
                               
                            <div className="col-3 my-1">
                                <label htmlFor="client_id" >CLIENT</label>


                                <InputAuto name="client_company_name" className="form-control" minStart="3"
                                    value={woSearch.client_company_name}
                                    pholder=""
                                    data={clients}
                                    field="client_company_name"
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, client_company_name: e })
                                    }
                                    onSelected={(e) => {
                                        setWoSearch({ ...woSearch, client_company_name: e.client_company_name })

                                    }
                                    }

                                />

                            </div>


                            <div className="col-2 my-1">
                                <label htmlFor="client_id" >CASE MANAGER</label>


                                <input name="case_manager_first_name" className="form-control" type="text"
                                    value={woSearch.case_manager_first_name}
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, case_manager_first_name: e.target.value })
                                    }


                                />
                            </div>




                        </div>


                    </form >

                </div >

                <div className="card-footer">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                            <button onClick={() => searchWorkOrders()} className="btn btn-success mx-1" type="button" disabled={isLoading ? true : false} >{isLoading ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "GENERATE"} </button>

                            {workOrders &&
                                <CSVLink data={workOrders} headers={csvHeader} className="btn btn-warning mx-1" >DOWNLOAD</CSVLink>
                            }
                            <button onClick={() => { setWoSearch(null) }} className="btn btn-danger mx-1" type="button">CLEAR </button>

                        </div>

                    </div>
                </div>
            </div >




            {(workOrders || isLoading) &&

                <div className="card card-form card-primary mt-4 " >
                    <div className="card-body p-0 mb-0" >

                        {isLoading ?
                            <div className="loader">
                                <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                            </div>
                            :
                            <PrimaryTable columns={columns} data={workOrders} canFilter={false} />
                        }


                    </div>
                </div>

            }


        </>


    );
};

export default CanceledWOs;